import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChange,
  ViewChild,
  ViewRef,
} from '@angular/core';
import { NgModel } from '@angular/forms';

import { DatepickerSettingModel } from './datepicker.model';

@Component({
  selector: 'pivot-datepicker-calendar',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})

export class DatepickerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() currentDate: any;
  @Input() dateMask: any = [/\d/, /\d/, /\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
  @Input() placeholder: string;
  @Input() isJPExtend = false;
  @Input() showExternal = false;
  @Input() allowNull = true;
  @Input() disabled = false;
  @Input() isShowOutline = false;
  @Input() isFormControl = false;
  @Input() inpControlName = '';
  @Input() errorMessage = '';
  @Output() dateChanged: EventEmitter<Date> = new EventEmitter();
  @Output() calendarControlReady = new EventEmitter<NgModel>();
  @Output() calendarControlDestroy = new EventEmitter<NgModel>();
  @Output() calendarControlFocusout = new EventEmitter<any>();
  @Output() calendarControlFocusin = new EventEmitter<any>();
  myModel: string;
  jpErasFunc = new DatepickerSettingModel();
  jpEras = new DatepickerSettingModel().jpEras;
  private calendarCtrl: NgModel;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  @ViewChild(NgModel)
  set page(content: NgModel) {
    if (content) {
      this.calendarCtrl = content;
    }
  }

  ngAfterViewInit() {
    this.calendarControlReady.emit(this.calendarCtrl);
  }

  ngOnDestroy() {
    this.calendarControlDestroy.emit(this.calendarCtrl);
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        if (propName === 'currentDate') {
          if (!this.currentDate) {
            this.myModel = '';
          } else {
            if (typeof this.currentDate.getMonth !== 'function') {
              this.currentDate = new Date(this.currentDate);
            }
            this.myModel = this.convertToYMD();
          }
        }
        this.disabled = false;
        if (propName === 'disabled') {
          this.disabled = changes[propName].currentValue;
        }
      }
    }
  }

  focusout(event: any) {
    this.calendarControlFocusout.emit(event);
  }

  focusin(event: any) {
    this.calendarControlFocusin.emit(event);
  }

  convertToYMD() {
    if (this.currentDate === 'Invalid Date' || isNaN(this.currentDate)) {
      this.currentDate = new Date();
    }
    const mm = this.currentDate.getMonth() + 1;
    const dd = this.currentDate.getDate();
    const yy = this.currentDate.getFullYear();
    if (this.isJPExtend) {
      const jpEra = this.jpErasFunc.findEraYear(this.currentDate);
      const eraNames = jpEra.name.split('');
      const eraYear = yy - jpEra.startYear + 1;
      this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
      for (let i = eraNames.length - 1; i >= 0; i--) {
        this.dateMask.unshift(eraNames[i]);
      }
      return [(eraYear > 9 ? '' : '0') + eraYear, (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('');
    } else {
      return [yy, (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('');
    }
  }

  changeInput(event: any) {
    try {
      const value = event.target.value;
      if (this.isJPExtend) {
        const arr = value.split('年');
        const jpY = arr[0].split(/[0-9]+/)[0];
        let jpEra = this.jpEras.find(era => era.name === jpY);
        if (jpEra) {
          let year = Number(arr[0].replace(jpY, '').toString());
          year += jpEra.startYear - 1;
          let dateRemoveChar = value.replace(arr[0], '')
            .replace('年', '-')
            .replace('月', '-')
            .replace('日', '');
          dateRemoveChar = year + dateRemoveChar;
          dateRemoveChar = this.formatDate(dateRemoveChar);
          this.currentDate = new Date(dateRemoveChar);
          if (this.currentDate === 'Invalid Date' || isNaN(this.currentDate)) {
            jpEra = this.jpErasFunc.findEraYear(new Date());
            this.myModel = jpEra.name + '__年__月__日';
            if (this.cdr && !(this.cdr as ViewRef).destroyed) {
              this.cdr.detectChanges();
            }
          }
        } else {
          this.currentDate = null;
          jpEra = this.jpErasFunc.findEraYear(new Date());
          this.myModel = jpEra.name + '__年__月__日';
          if (this.cdr && !(this.cdr as ViewRef).destroyed) {
            this.cdr.detectChanges();
          }
        }
      } else {
        let dateRemoveChar = event.target.value.replace('年', '-')
          .replace('月', '-')
          .replace('日', '');
        dateRemoveChar = this.formatDate(dateRemoveChar);
        this.currentDate = new Date(dateRemoveChar);
        if (this.currentDate === 'Invalid Date' || isNaN(this.currentDate)) {
          this.myModel = '____年__月__日';
          if (this.cdr && !(this.cdr as ViewRef).destroyed) {
            this.cdr.detectChanges();
          }
        }
      }
      if (this.currentDate === null) {
        this.dateChanged.emit(null);
      } else if (this.currentDate !== 'Invalid Date' && !isNaN(this.currentDate)) {
        this.dateChanged.emit(this.currentDate);
      } else {
        if (this.allowNull) {
          this.dateChanged.emit(null);
        } else {
          this.dateChanged.emit(new Date());
        }
      }
    } catch (e) {
      if (this.allowNull) {
        this.dateChanged.emit(null);
      }
    }
  }

  keyUp(event: any) {
    const start = event.target.selectionStart;
    if (event.target.value.length === 0) {
      if (this.isJPExtend) {
        const jpEra = this.jpErasFunc.findEraYear(new Date());
        event.target.value = jpEra.name + '__年__月__日';
        if (start === 8) {
          this.changeInput(event);
        }
      } else {
        event.target.value = '____年__月__日';
      }
    } else {
      if (start === 10) {
        this.changeInput(event);
      }
    }
  }

  keyDown(event: any) {
    if (this.isJPExtend) {
      switch (event.key.toUpperCase()) {
        case 'R':
          this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
          this.dateMask.unshift('和');
          this.dateMask.unshift('令');
          break;
        case 'H':
          this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
          this.dateMask.unshift('成');
          this.dateMask.unshift('平');
          break;
        case 'S':
          this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
          this.dateMask.unshift('和');
          this.dateMask.unshift('昭');
          break;
        case 'T':
          this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
          this.dateMask.unshift('正');
          this.dateMask.unshift('大');
          break;
        case 'M':
          this.dateMask = [/\d/, /\d/, '年', /\d/, /\d/, '月', /\d/, /\d/, '日'];
          this.dateMask.unshift('治');
          this.dateMask.unshift('明');
          break;
      }
    }
  }

  setSelectionRange(event) {
    const start = event.target.selectionStart;
    if (start < 5) {
      if (this.isJPExtend) {
        event.target.selectionStart = 2;
      } else {
        event.target.selectionStart = 0;
      }
      event.target.selectionEnd = 4;
    } else if (start < 9) {
      event.target.selectionStart = 5;
      event.target.selectionEnd = 7;
    } else if (start < 11) {
      event.target.selectionStart = 8;
      event.target.selectionEnd = 10;
    }
  }

  formatDate(dateStr: string) {
    const dateArr = dateStr.split('-');
    const year: number = +dateArr[0];
    let month: number = +dateArr[1];
    let day: number = dateArr[2] === '0' ? 1 : +dateArr[2];
    // check month
    if (month > 12) {
      month = 12;
    }
    // check leapYear
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0 && year % 400 !== 0)
      || (year % 100 === 0 && year % 400 === 0);
    if (isLeapYear && month === 2 && day > 29) {
      day = 29;
    }
    if (!isLeapYear && month === 2 && day > 28) {
      day = 28;
    }
    // check day
    const monthHave31sDays = [1, 3, 5, 7, 8, 10, 12];
    const monthHave30Days = [4, 6, 9, 11];
    if (monthHave31sDays.includes(month) && day > 31) {
      day = 31;
    }
    if (monthHave30Days.includes(month) && day > 30) {
      day = 30;
    }

    return year + '-' + month + '-' + day;
  }
}
